import { combineReducers } from '@reduxjs/toolkit';
import authReducer from '../authSlice';
import storage from 'redux-persist/lib/storage';

const combinedReducer = combineReducers({
  auth: authReducer,
});

export type RootState = ReturnType<typeof combinedReducer>;

const rootReducer = (state: any, action: any) => {
  if (action.type === 'auth/logout') {
    storage.removeItem('persist:root');
    state = undefined;
  }
  return combinedReducer(state, action);
};

export default rootReducer;
